import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { validateRoom } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-edit-playroom-modal',
  templateUrl: './edit-playroom-modal.component.html',
  styleUrls: ['./edit-playroom-modal.component.scss'],
})
export class EditPlayroomModalComponent implements OnInit {
  errMsg = '';
  room: Playroom;

  name: string;
  address: string;
  telephone: string;

  constructor(private modalController: ModalController, private roomService: PlayroomService) { }

  ngOnInit() {
    this.room.managerId = this.room.manager?.id;
    this.room.workingHoursFrom = this.parseTime(this.room.workingHoursFrom);
    this.room.workingHoursTo = this.parseTime(this.room.workingHoursTo);
  }

  parseTime(datetime) {
    let hours = new Date(datetime).getHours().toString();
    hours = hours.length === 1 ? `0${hours}` : hours;
    let minutes = new Date(datetime).getMinutes().toString();
    minutes = minutes.length === 1 ? `0${minutes}` : minutes;
    return `${hours}:${minutes}`;
  }

  editRoom() {
    const formValidation = validateRoom(this.room);
    this.errMsg = formValidation.errMsg;
    if(formValidation.isValid) {
      this.roomService.editPlayroom(this.room).subscribe(res => {
        this.roomService.getAllPlayrooms();
        this.dismissModal();
      },(err) => {
        console.error(err);
      });
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
